<ng-container class="report-details">
  <div class="report-incident-id qundis-inner-content mt-2 mb-3">
    <span>{{ vm()?.report?.incident_id }}</span>
  </div>
  <div class="report-solved-data qundis-inner-content">
    <div class="report-created my-2">
            <span
            >Erstellt von: {{ vm()?.created_by_user }} am
              {{ vm()?.report?.created_at | date : "short" : getTimeZoneString() : "de" }} Uhr
            </span>
    </div>
    <div class="report-created my-2" *ngIf="vm()?.escalation">
      <span
      >Weitergeleitet an: {{ vm()?.escalation?.assigned_to_role }} um {{
              vm()?.escalation?.created_at | date : "short" :
                  getTimeZoneString() : "de"
        }} Uhr
      </span>
    </div>

    <div class="report-created my-2" *ngIf="vm()?.escalationAcceptedUserName">
            <span
            >Aktueller Eskalationsstatus: {{ getEscalationStatus(vm()?.escalation?.status!) }}
            </span>
    </div>
    <div class="report-created my-2" *ngIf="vm()?.escalationAcceptedUserName">
            <span
            >Angenommen von: {{ vm()?.escalationAcceptedUserName }}
            </span>
    </div>

    <div class="report-solved my-2" *ngIf="vm()?.report?.solved_on">

            <span
            >Gelöst von: {{ vm()?.solved_by_user }} am
              {{ vm()?.report?.solved_on | date : "short" : getTimeZoneString() : "de" }} Uhr
            </span>
    </div>
  </div>
  <div
    class="report-downtime qundis-inner-content"
    *ngIf="vm()?.report?.solved_on"
  >
    Stillstandsdauer:
    {{ downtime || "Noch nicht gelöst" }}
  </div>
</ng-container>
